var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpecialization(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6994 5.29998C12.5161 5.48691 12.4135 5.73823 12.4135 5.99998C12.4135 6.26173 12.5161 6.51305 12.6994 6.69998L14.2994 8.29998C14.4863 8.48321 14.7376 8.58584 14.9994 8.58584C15.2611 8.58584 15.5124 8.48321 15.6994 8.29998L19.4694 4.52998C19.9722 5.64117 20.1245 6.87921 19.9058 8.07913C19.6872 9.27904 19.1081 10.3838 18.2456 11.2463C17.3832 12.1087 16.2784 12.6878 15.0785 12.9064C13.8786 13.1251 12.6406 12.9728 11.5294 12.47L4.61937 19.38C4.22154 19.7778 3.68198 20.0013 3.11937 20.0013C2.55676 20.0013 2.01719 19.7778 1.61937 19.38C1.22154 18.9822 0.998047 18.4426 0.998047 17.88C0.998047 17.3174 1.22154 16.7778 1.61937 16.38L8.52937 9.46998C8.02653 8.35879 7.87428 7.12075 8.09291 5.92083C8.31154 4.72092 8.89065 3.61614 9.75309 2.7537C10.6155 1.89127 11.7203 1.31215 12.9202 1.09352C14.1201 0.874895 15.3582 1.02714 16.4694 1.52998L12.7094 5.28998L12.6994 5.29998Z",
    stroke: "#1B2028",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecialization);
export default __webpack_public_path__ + "static/media/specialization.be77922164359d9a45e99165a1c4f7c6.svg";
export { ForwardRef as ReactComponent };